import getEffectiveCharacteristicSkillAdjs from './getEffectiveCharacteristicSkillAdjs'

//-------------------------------------------------
// sync armour dex characteristic skill adjustment
//-------------------------------------------------
export default function syncArmourDexCharacteristicSkillAdj(character = null) {
  if (!character) return character

  character.characteristic_skill_adjs = getEffectiveCharacteristicSkillAdjs(character)
  return character
}
